import { VisionMap } from '../../map/map';
import { VisionRockingTab } from './rocking';

export class RockingMap {
    parent: VisionRockingTab;
    map!: VisionMap;

    constructor(parent: VisionRockingTab) {
        this.parent = parent;

        //this.parent.layout.cells('b').attachHTMLString('<div id="rocking_map_id" style="width:100%;height:100%"></div>');

        this.parent.layout.cells('b').attachHTMLString(`<div id='rocking_map_id' style='width: 100%;height: 100%;margin: 0px;padding: 0px;'></div>

        <div id="legend-rocking" style="background: white; padding: 10px; margin: 10px; font-size: 14px;font-family: Arial, sans-serif;">
        <div class="legend-title" style="font-weight: bold;">Completion</div>
        <div class="legend-scale" style="display: flex; align-items: center; margin-bottom: 5px;">
        
         <ul style="list-style: none; padding: 0; margin: 0;">
    <li><span style="display: inline-block; width: 16px; height: 16px; background: rgb(255, 0, 0); margin-right: 8px; border: 1px solid #aaa;"></span> < 5% — Red</li>
    <li><span style="display: inline-block; width: 16px; height: 16px; background: rgb(255, 165, 0); margin-right: 8px; border: 1px solid #aaa;"></span> 5% – 50% — Orange</li>
    <li><span style="display: inline-block; width: 16px; height: 16px; background: rgb(255, 255, 0); margin-right: 8px; border: 1px solid #aaa;"></span> 50% – 90% — Yellow</li>
    <li><span style="display: inline-block; width: 16px; height: 16px; background: rgb(0, 128, 0); margin-right: 8px; border: 1px solid #aaa;"></span> 90% – 100% — Green</li>
    <li><span style="display: inline-block; width: 16px; height: 16px; background: rgb(128, 0, 128); margin-right: 8px; border: 1px solid #aaa;"></span> > 100% — Purple</li>
  </ul>

      </div>
        `);
        this.parent.layout.cells('b').hideHeader();

        this.map = new VisionMap('rocking_map_id');
    }
}
